// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { translate } from "react-i18next";
import ResourceLabel from './resourceLabel/ResourceLabel';
import ResourceDetails from './ResourceDetails';
import DefaultButton from '../../../components/DefaultButton';
import TextInput from '../../../components/TextInput';
import IconCancel from './../../../icons/cancel.svg';
import { loadResourcesDetails } from '../../../actions/resource';
import throttle from '../../../utilities/throttle';
import _ from 'lodash';

const ResourceTabTitle = styled.h3`
    margin: 0 5px;
`;

const MessageWrapper = styled.div`
    display: flex;
    align-items: center;
    height: calc(100% - 50px);
    >p{
        margin-left: 5px;
        text-align: center;
    }
`;

const ThumbnailResourceWraper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: hidden;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
`;

const ResourcesContainer = styled.div`
    overflow: auto;
    height: calc(100% - 92px);
    overflow-x: hidden;
    overflow-y: auto;
    border-top: 1.5px solid rgba(128, 128, 128, 0.2);
`;

const TitleWrapper = styled.div`
    width: 100%;
    background: linear-gradient(0deg, #263650 0%, #082242 100%);
    color: #ffffff;
    padding: 5px;
    height: 25px;
    display: ${props => props.visible ? 'block' : 'none'};
    margin-bottom: 5px;
`;
const ResourceListRow = styled.div`
    width: 100%;
    background-color: #ffffff;
    margin: 5px;
    border-radius: 5px;
    width: calc(100% - 12px);
    border: 1px solid #ebebeb;
`;

const LeftBox = styled.div`
    align-items: center;
    position: relative; 
    float: left; 
    width: calc(100% - 44px);
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
    font-weight: 600;
    color: #2d2d2d;
    padding: 5px;
`;

const RightBox = styled.div`
    align-items: center;
    position: relative; 
    float: right; 
    width: 20px;
    margin: 0px 5px 0px 0px;
`;

const RowBox = styled.div`
    display: flex;
    width: 100%;
`;

export class ResourceModeContent extends React.Component {
    filterInput: any
    constructor() {
        super();
        this.state = {
            filterTerm: "",
            selectedResources: [],
            rowsLimit: 20,
            selectDetailsId: -1,
        }
    }

    componentDidMount() {
        const { loadResourcesDetails, axiosInstance, chosenFlight } = this.props;
        loadResourcesDetails(axiosInstance, chosenFlight ? chosenFlight.id : 0);
    }

    componentDidUpdate(prevProps, prevState) {
        const { loadResourcesDetails, axiosInstance, chosenFlight } = this.props;
        if (!_.isEqual(prevProps.chosenFlight, chosenFlight)) {
            loadResourcesDetails(axiosInstance, chosenFlight ? chosenFlight.id : 0);
        }
    }

    resourceChangeHandler(value, resourceID) {
        if (this.state.selectDetailsId !== resourceID) {
            this.setState({
                selectDetailsId: resourceID,
            })
        } else {
            this.setState({
                selectDetailsId: -1,
            })
        }
    }

    render() {
        const { chosenFlight, resourcesDetails, t } = this.props;

        const { filterTerm } = this.state;
        if (!chosenFlight) {
            return (
                <ThumbnailResourceWraper>
                    <TitleWrapper visible={true}>
                        <ResourceTabTitle>
                            {t('Attachments')}:
                        </ResourceTabTitle>
                    </TitleWrapper>
                    <MessageWrapper>
                        <p> {chosenFlight ? t('No attachments for mission') : t('No mission selected please select')} </p>
                    </MessageWrapper>
                </ThumbnailResourceWraper>);
        }

        return (
            <ThumbnailResourceWraper>
                <TitleWrapper visible={true}>
                    <ResourceTabTitle>
                        {t('Attachments')}:
                    </ResourceTabTitle>
                </TitleWrapper>
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                    }}>
                    <TextInput
                        style={{
                            display: resourcesDetails.length > 0 ? 'block' : 'none',
                            width: 'calc(100% - 14px)',
                            margin: '2px 7px 2px 6px',
                        }}
                        ref={(node) => { this.filterInput = node }}
                        type="text"
                        placeholder={t('Search') + '...'}
                        onChange={(event) => {
                            const { value } = event.target;
                            throttle.run(() => {
                                this.setState({ filterTerm: value })
                            }, 500)
                        }}
                    />
                    <DefaultButton
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '4px',
                        }}
                        visible={filterTerm !== ''}
                        title={t('Clear')}
                        onClick={() => {
                            this.setState({
                                filterTerm: ''
                            })
                            this.filterInput.domNode.value = '';
                        }}>
                        <ReactSVG
                            path={IconCancel}
                            style={{
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </DefaultButton>
                </div>

                {resourcesDetails.length > 0
                    ? <ResourcesContainer
                        onScroll={(e) => {
                            const threshold = 50;
                            const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + threshold
                            if (bottom) {
                                throttle.run(() => {
                                    this.setState({ rowsLimit: this.state.rowsLimit + 20 })
                                }, 500)
                            }
                        }}
                    >
                        {resourcesDetails
                            .filter(resourceDetails => {
                                const { fileName } = resourceDetails;
                                return fileName.toUpperCase().includes(filterTerm.toUpperCase())
                            })
                            .slice(0, this.state.rowsLimit)
                            .map(resourceDetails => {
                                return (
                                    <ResourceListRow key={resourceDetails.id}>
                                        <LeftBox
                                            title={resourceDetails.fileName}
                                            onClick={(e) => {
                                                this.resourceChangeHandler(e.target.value, resourceDetails.id);
                                            }}>
                                            {resourceDetails.fileName}
                                        </LeftBox>
                                        <RightBox>
                                            <ResourceLabel key={resourceDetails.id} resource={resourceDetails} />
                                        </RightBox>
                                        <RowBox>
                                            <ResourceDetails
                                                resourceDetails={resourceDetails}
                                                visible={this.state.selectDetailsId === resourceDetails.id}
                                            />
                                        </RowBox>
                                    </ResourceListRow>
                                )
                            })}
                    </ResourcesContainer>
                    : <MessageWrapper>
                        <p>
                            {t('No attachments')}
                        </p>
                    </MessageWrapper>}
            </ThumbnailResourceWraper>
        );
    };
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    resourcesDetails: state.resource.get('resources_details'),
    chosenFlight: state.flightManager.get('chosenFlight'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    loadResourcesDetails,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ResourceModeContent));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/ResourceModeContent.jsx